import React, { useState, useEffect} from 'react';
import { Grid} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import services from './../../store/services';
import SaleRoomChart from "./SaleRoomChart";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        paddingTop: 0,
        borderTopStyle: "solid",
        borderTopColor: theme.lpb.borderColor,
        borderTopWidth: 1
    },
    container: {
        display: "flex-grow",
    }
}));

function SaleDisplayBottom(props) {
    const classes = useStyles();

    const [roomTotals, setRoomTotals] = useState([]);
    const [maxLots, setMaxLots] = useState(0);


    const calcMaxLots = (allLots, maxOfLots) => {
        if (allLots < 1 || maxOfLots >= allLots) {
            return maxLots;
        }
        let calcedMax = allLots;
        if (allLots <= 10) {
            calcedMax = 10;
        } else if (allLots < 100) {
            calcedMax = Math.round(Math.ceil(allLots / 10)) * 10;
        } else if (allLots < 1000) {
            calcedMax = Math.round(Math.ceil(allLots / 100)) * 100;
        } else if (allLots < 10000) {
            calcedMax = Math.round(Math.ceil(allLots / 1000)) * 1000;
        } else if (allLots < 100000) {
            calcedMax = Math.round(Math.ceil(allLots / 10000)) * 10000;
        }
        return calcedMax;

    };

    const getTotals = () => {
        if (!props.saleIdSelectValue || !props.lastUpdate) {
            return;
        }
        let query = "saleDayId=" + encodeURI(props.saleIdSelectValue);
        //>>User Story 34401: INROOM Display Changes
        /*
        if (props.saleDisplayType) {
            query = query + "&roomNo= 1";
        }
        */
        query += "&awexOnly=" + encodeURI(props.ckAWEXSelectedValue);

        if (props.roomNo) {
            query = query + "&roomNo=" + encodeURI(props.roomNo);
        }
        else if (props.saleDisplayType) {
            query = query + "&roomNo=1";
        } 

        if (props.sellerSelectedValue !== "-1") {
            query = query + "&seller=" + encodeURI(props.sellerSelectedValue);
        }
        if (props.buyerSellectedValue !== "-1") {
            query = query + "&buyer=" + encodeURI(props.buyerSellectedValue);
        }
        //<<User Story 34401: INROOM Display Changes

        services.getTotals(query)
            .then(response => {
                let maxOfLots = 0;
                for (var i = 0; i < response.data.length; i++) {
                    const room = response.data[i];
                    const allLots = room.qtySold + room.qtyUnsold;
                    if (allLots >= 1 && maxOfLots <= allLots) {
                        maxOfLots = calcMaxLots(allLots);
                    }
                }
                setMaxLots(maxOfLots);
                setRoomTotals(response.data);
        });
    }

    useEffect((props) => {
        getTotals();
    }, [props.saleIdSelectValue, props.saleDisplayType, props.ckAWEXSelectedValue, props.roomNo, props.sellerSelectedValue, props.buyerSellectedValue, props.lastUpdate]);

    const resultChart = () => {
        if (roomTotals.length < 1) {
            return "";
        }

        return roomTotals.length > 1 ? (
            <>
                {roomTotals.map(room => (
                    <Grid item xs={6} key={room.roomNo}>
                        <SaleRoomChart roomData={room} maxLots={maxLots}  />
                    </Grid>
                ))}
            </>
        )
            :
            (
                <>
                    <SaleRoomChart roomData={roomTotals[0]} maxLots={maxLots} />
                </>
            );
    }

    return (
        <div className={classes.root}>
            <Grid container spacing={0} className={classes.container}>
                {resultChart()}
            </Grid>
        </div>
    );
}

export default SaleDisplayBottom;



